<template>  
    <table id="networkMsgBox" class="networkmsg" border="0" style="display: none; ">
      <tr>
        <td><div style="font-size: 16px; text-align: center">Hmm... </div></td>
      </tr>
      <tr>
        <td><div style="font-size: 14px; text-align: center; margin-top: 2vh">your internet connection is slow, for a better experience please try switching to WIFI if available</div></td>
      </tr>
    </table>
    <!-- showPopUpOk --><transition name="fade">
    <div v-show="showPopUpOk" class="modal-overlayfrombottomblur" :class="this.showOld===true ? 'wrapper-todiv' : 'wrapper-todiv-new'" style="z-index: 999;">
      <div class="modalnotbootstrap"  style="padding-top: 3vh; padding-bottom: 3vh; min-height: 40vh; width: 80%"> 
        <!-- put in table for dev speed need to learn more about flex -->
        <table border=0 width=80%> 
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': this.fontSizeTitle + 'vh', 'line-height': this.fontSizeTitleLineHeight + 'vh', }">                 
              {{ this.popUpMsgTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': this.fontSizePopUpMsg + 'vh', 'line-height': this.fontSizePopUpMsgLineHeight + 'vh', 'padding-top': '1vh', }" style="overflow-wrap: anywhere;">                 
              {{ this.popUpMsgBody }}
              </div>
            </td>
          </tr>
          <tr v-show="!this.suppressOk">
            <td style="height: 10vh">
              <div><button class="widebtn" ref="show-popup-ok" style="width: 50%; height: 6vh; " @click="this.doPopUpOk();">Ok</button></div>
            </td>
          </tr>
          <tr> <!-- spacer --> <td><div></div></td>
          </tr>
        </table>       
      </div>
    </div>
  </transition>
   <!-- showPopUpTwoOptions --><transition name="fade">
    <div  v-show="showPopUpTwoOptions" class="modal-overlayfrombottomblur" :class="this.showOld===true ? 'wrapper-todiv' : 'wrapper-todiv-new'"  style="z-index: 997;">
      <div class="modalnotbootstrap" style="padding-top: 2vh; padding-bottom: 2vh; width: 90%"> 
        <!-- put in table for dev speed need to learn more about flex -->
        <table border=0 width=85%> 
          <tr>
            <td>
              <div class="lt-blue txtc" :style="{ 'font-size': fontSizeNormalInPXToUse * 1.1 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }">                 
              {{ this.PopUpTwoOptionsTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="lt-blue txtc"  :style="{ 'font-size': fontSizeNormalInPXToUse * 0.9 + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }" style="overflow-wrap: anywhere; padding-top: 1vh;">                 
               {{ this.PopUpTwoOptionsMessage }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="padding-top: 2vh; padding-bottom: 2vh;"><button class="widebtn" style="width: 80%; height: 5vh; " :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }" @click="this.doOption1();">{{ this.option1ButtonText }}</button></div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="padding-bottom: 2vh;"><button class="widebtn" style="width: 80%; height: 5vh; " :style="{ 'font-size': fontSizeNormalInPXToUse + 'px', 'line-height': fontSizeNormalInPXLineHeightToUse + 'px', }" @click="this.doOption2();">{{ this.option2ButtonText }}</button></div>
            </td>
          </tr>
          <tr> <!-- spacer --> <td><div></div></td>
          </tr>
        </table>       
      </div>
    </div>
  </transition>
  
  <TippingScreen :key="componentKeyTip" v-if="this.tuid" :tuid='this.tuid' :showGetTipsHereButton='this.showGetTipsHereButton' @return-parent-json="returnJSON" @reset-me="resetTippingScreen"/>
  <!-- NEW COMPONENT IMPORT for JS only -->
  <HomeScreen :key="homeScreenToggle" v-if="showHomeScreen" :tuRedirect='this.redirect' :redirectParam1='this.redirectParam1' :fromScreen='this.fromScreen' :showHomePageFromGoogleAd='this.showHomePageFromGoogleAd' @return-parent-json="returnJSON"/>

  <AccountScreen :key="componentKeyAccount" v-if="showAccount" :bypassDashboard='this.bypassDashboard' @return-parent-json="returnJSON"/>

  <LandingScreen v-if="showLanding" @return-parent-json="returnJSON"/>
  <LoadParseFromHome :key="loadParseToggle" v-if="this.loadParse !== false" :functionName='this.functionName' :paramsObject='this.paramsObject' @return-parent-json="returnParseJSON"/>
  <!-- <LoadLogRocketFromHome :key="loadLogRocketToggle" v-if="this.loadLogRocket !== false" :logRocketOrganisationSlug='this.logRocketOrganisationSlug' :tipperObjectId='this.tipperObjectId' :tipperDisplayname='this.tipperDisplayname'/> -->
  <!-- at the moment LoadLogRocketFromHome is never going to load, doing is all through LoadParseFromHome -->
</template>


<script>
import { defineAsyncComponent } from 'vue'

// so now the below is all async
// import TippingScreen from './components/Tipping.vue'
// import HomeScreen from './components/HomeContent.vue'
// import AccountScreen from './components/AccountPrep.vue'
// import LandingScreen from './components/Landing.vue'


// const Parse = require('parse/node');
// const Parse = require('parse/node');

// import shared from './shared.js';

// import LogRocket from 'logrocket';


export default {
  inject: ['showOld', 'globalPushForwardInterval', 'devEnv', 'appId', 'appJSKey'],
  name: 'App',
  components: {
    TippingScreen: defineAsyncComponent(() =>
      import('./components/Tipping.vue')
    ),
    HomeScreen: defineAsyncComponent(() =>
      import('./components/HomeContent.vue')
    ),
    AccountScreen: defineAsyncComponent(() =>
      import('./components/AccountPrep.vue')
    ),
    LandingScreen: defineAsyncComponent(() =>
      import('./components/Landing.vue')
    ),
    LoadParseFromHome: defineAsyncComponent(() =>
      import('./components/LoadParseFromHome.vue')
    ),
    // LoadLogRocketFromHome: defineAsyncComponent(() =>
    //   import('./components/LoadLogRocketFromHome.vue')
    // )
  },
  data() {
    return {
      showHomeScreen: true,
      showAccount: false,
      showLanding: false,
      tuid: undefined,
      showPopUpOk: false,
      popUpMsgTitle: "",
      popUpMsgBody: "",
      fontSizeTitle: 2.7, // vh
      fontSizeNormal: 2.4, // vh, not currently used
      fontSizeTitleLineHeight: 5, //vh
      fontSizePopUpMsg: 2.3, // vh
      fontSizePopUpMsgLineHeight: 3.4,// vh
      showPopUpTwoOptions: false,
      PopUpTwoOptionsTitle: "",
      PopUpTwoOptionsMessage: "",  
      option1ButtonText: "",
      option2ButtonText: "",
      showingProceedWithVenueConnectMessage: false,
      redirect: "",
      fromScreen: "",
      bypassDashboard: false,
      componentKeyTip: false,
      componentKeyAccount: false,
      loadParse: false,
      loadLogRocket: false,
      functionName: undefined,
      paramsObject: undefined,
      loadParseToggle: false,
      loadLogRocketToggle: false,
      logRocketOrganisationSlug: "",
      showHomePageFromGoogleAd: false,
      homeScreenToggle: false,
      showGetTipsHereButton: false,
      redirectParam1: undefined,
      tipperObjectId: "",
      tipperDisplayname: "",
      pendingtuid: "",
      reloading: false,
    }
  },
  methods: {
    resetTippingScreen() {
      console.log("[parent] resetting TippingScreen component");
      this.componentKeyTip++;
    },
    doPopUpOk(){
      this.showPopUpOk = false;
      // testing Dropbox update
    },
    doOption1(){
      this.showPopUpTwoOptions = false;
      this.resetPopUpTwoOptions();
      if (this.showingProceedWithVenueConnectMessage){
        this.showingProceedWithVenueConnectMessage = false;
        this.showAccount = true;
        console.log("HERE 2");
      }
    },
    doOption2(){
      this.showPopUpTwoOptions = false;
      this.resetPopUpTwoOptions();
      if (this.showingProceedWithVenueConnectMessage){
        this.showingProceedWithVenueConnectMessage = false;
        console.log("getting rid of localStorage items");
        window.localStorage.removeItem("tuconnecttovenue");
        window.localStorage.removeItem("tuconnecttovenueinprocess"); 
        if (window.localStorage.getItem("willConnectRealUserDetails") !== null) {
          // window.localStorage.removeItem("willConnectRealUserDetails");
          window.localStorage.removeItem("willConnectRealUserDetailsinprocess"); 
          window.localStorage.setItem("willConnectRealUserDetailsjustcancelled", "yes"); 
        } 
        this.tuid = undefined;
        this.showHomeScreen = true;
        this.homeScreenToggle = !this.homeScreenToggle;;
        // console.log("tuconnecttovenueinprocess removed");
        
      }
    },
    resetPopUpTwoOptions(){

      this.PopUpTwoOptionsTitle = "";
      this.PopUpTwoOptionsMessage = "";
      this.option1ButtonText = "";
      this.option2ButtonText = "";
      
    },
    returnParseJSON(returnJSON){
    
      // console.log("JSON returnParseJSON on App ::: " + JSON.stringify(returnJSON));

      if (returnJSON.functionName === "validateUserLinkDetails"){
        // console.log("I am about to getURLDataIfAnyAndSetPart2");
        this.getURLDataIfAnyAndSetPart2(returnJSON);
      } else if (returnJSON.functionName === "fetchUserDetails"){
        
        window.localStorage.setItem("tuisrecipient", returnJSON.isRecipient);

        this.doPostGetUserDataIfNecessary();
        

        ////console.log("isRecipient::: " + window.localStorage.getItem("tuisrecipient"));

        // this.popUpMsgTitle = "Great";
        // this.popUpMsgBody = "FETCHED isRecipient:: " + window.localStorage.getItem("tuisrecipient");
        // this.showPopUpOk = true;

      } else {
        // console.log(returnJSON.functionName + "completed with return value: " + JSON.stringify(returnJSON, null, 2));
      }
    
    },

    returnJSON(returnJSON){


      // console.log("JSON on App ::: " + JSON.stringify(returnJSON));
      
      if (returnJSON.selectedTUID){
        
        ////console.log("this.showHomeScreen::: " +  returnJSON.showHomeScreen);

        this.showHomeScreen = returnJSON.showHomeScreen;
        this.showAccount = false;

        this.componentKeyAccount = !this.componentKeyAccount;

        this.tuid = returnJSON.selectedTUID;

        this.componentKeyTip = !this.componentKeyTip;

        // this.tuid = returnJSON.selectedTUID;

        //couldn't get to the bottom of this - for some reason the symchonrous call above would cause the homescreen to show again but WITHOUT triggering renderTriggered. I only know because it DOES fire created() - so this tiny timeout is enough for this.showHomeScreen = returnJSON.showHomeScreen; to hide the main screen without this.tuid = returnJSON.selectedTUID for some strange reason causing it to show again 

        // I actually think the reason for this was we needed component key - I have just confirmed that is the case

        // setTimeout(() =>  {
        //   ////console.log("timout returnJSON.selectedTUID ::: " + returnJSON.selectedTUID);
        //   // window.localStorage.setItem("tuid", returnJSON.selectedTUID); 
        //   // return;
        //   this.tuid = returnJSON.selectedTUID;
        //   } , 5);

        

        // // /////console.log("App tuid::: " + this.tuid);
        // /////console.log("App showHomeScreen::: " + this.showHomeScreen);
      } else if (returnJSON.showAccount){

        ////console.log("App.vue is showing account");
        this.showHomeScreen = returnJSON.showHomeScreen;
        if (returnJSON.bypassDashboard) {
          ////console.log("returnJSON.bypassDashboard: " + returnJSON.bypassDashboard);
          this.bypassDashboard = true;
        }
        this.showAccount = true;
        console.log("HERE 3");
        
      } else if (returnJSON.showHomeScreen){

        console.log("doing this");

        this.showAccount = false; 
        if (returnJSON.redirect !== undefined) {

          if (returnJSON.redirect === "showLoggedOut") {
            this.popUpMsgTitle = "That's a wrap..";
            this.popUpMsgBody = "You have successfully logged out. Tap the account icon top right to log back in again.";
            this.showPopUpOk = true;
          } else { 
            // console.log("returnJSON.fromScreen: " + returnJSON.fromScreen);
            this.redirect = returnJSON.redirect;
            this.fromScreen = returnJSON.fromScreen;
            // console.log("this.fromScreen: " + this.fromScreen);
          }
        }

        this.tuid = undefined;

        ////console.log("LOCALSTORAGE: " + JSON.stringify(window.localStorage));

        if (returnJSON.redirect === undefined && window.localStorage.getItem("tuisrecipient") !== null && window.localStorage.getItem("tuisrecipient") === "true") {
          console.log("going to ACCOUNT as RECIPIENT");
          // alert("going to ACCOUNT");

          if (window.localStorage.getItem("strConnAccId") !== null || window.localStorage.getItem("ryftConnAccId") !== null ){
            // fine
          } else {
            this.bypassDashboard = true;
          }
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 4");
          console.log("I'm doing THIS showAccount");

          this.componentKeyAccount = !this.componentKeyAccount;
        
        } else if (window.localStorage.getItem("willConnectRealUserDetails") !== null && window.localStorage.getItem("willConnectRealUserDetailsjustcancelled") === null ) {
          console.log("showing Account from APP because of willConnectRealUserDetails");
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 5");
        } else if (window.localStorage.getItem("masterregisteringqrcode") !== null) {
          ////console.log("showing Account from APP because of masterregisteringqrcode");
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 6");
        
        } else {
          // alert("STAYING NORMAL");
          console.log("SHOWING NORMAL");

          if (window.localStorage.getItem("willConnectRealUserDetailsjustcancelled") !== null){
            console.log("CLEARLING ALL LOCAL STORAGE");
            window.localStorage.clear(); // remove the lot they can start again
          } 

          this.showAccount = false;
          this.showHomeScreen = returnJSON.showHomeScreen;
        }

      }
    },
    doIt(){
      this.tuid = '00000000002';
    },
    getTUID(){

      ////console.log("window.location.search: " + window.location.pathname);

      if (window.location.pathname === "/jw") {
        this.showHomeScreen = false;
        this.tuid = "00000000435";
        return;
      } else if (window.location.pathname === "/jwc") {
        this.showHomeScreen = false;
        this.tuid = "00000000800";
        return;
      }

      let urlParams = new URLSearchParams(window.location.search);
      // /////console.log(urlParams.has('tuid')); // true

      if (urlParams.has('tuid')){
        
        if (window.localStorage.getItem("willConnectRealUserDetails") !== null) {
          console.log("showing Account because of willConnectRealUserDetails");
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 7");
        } else if (window.localStorage.getItem("masterregisteringqrcode") !== null) {
          ////console.log("showing Account because of masterregisteringqrcode");
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 8");
        } else {
          this.showHomeScreen = false;
          // window.localStorage.setItem("tuid", urlParams.get('tuid'));  was thinking about it but don't need it
          this.tuid = urlParams.get('tuid');
      
        }
      } else {
        if (window.localStorage.getItem("fullThisDataSet") !== null) {
            this.reloading = true;
            let fullThisDataSet = JSON.parse(window.localStorage.getItem("fullThisDataSet"));

            if (fullThisDataSet.rebuildStateValidityMilliseconds !== undefined && fullThisDataSet.rebuildStateValidityMilliseconds < (new Date().getTime() - 600000)){ // 10 minutes before it goes stage 
              // it's over 10 minutes old so it's out of date and lapsed
              console.log("removing stale fullThisDataSet");
              window.localStorage.removeItem("fullThisDataSet");
            } else {
              console.log("restoring state to fullThisDataSet");
              this.showHomeScreen = false;
              this.showAccount = false;
              console.log("HID ACCOUNT SCREEN");
              this.pendingtuid = fullThisDataSet.tuid;
              this.logRocketOrganisationSlug = fullThisDataSet.logRocketOrganisationSlug;
              if (window.localStorage.getItem("tuob") !== null){
                this.tipperObjectId = window.localStorage.getItem("tuob")
              }
              if (window.localStorage.getItem("tudis") !== null){
                this.tipperDisplayname = window.localStorage.getItem("tudis")
              }

              // I took this out, first because I think the reloading is working fine so no need to monitor, and secondly because I think it is messing up LogRocket
              // this.loadLogRocket = true;
              // this.loadLogRocketToggle = !this.loadLogRocketToggle;
              // this is an attempt to ensure Logrocket will have loaded
              window.setTimeout(this.activateTUID, 300); 
                        
            }

        }
      }
      if (urlParams.has('connect')){
        this.showGetTipsHereButton = true;
      }

    },
    activateTUID(){
      console.log("activating TUID has LogRocket loaded?")
      this.tuid = this.pendingtuid; // only want to activate TUID now, after LogRocket
    },
    async deployLogRocket(userObjectId){

      
      // var LRDisplayname = "LR user activating";

      // if (window.localStorage.getItem("tudis") !== null) {
      //   LRDisplayname = window.localStorage.getItem("tudis") + " activating";
      // }

      // try {


        // console.log(":about to Logrocket");

        // app.component("LogRocket", LogRocket);



        //  if (!app._context.components[componentName]) {
        //       app.component(
        //           componentName,
        //           defineAsyncComponent(() => import('logrocket')),
        //       );
        //   }

        // const LogRocket = defineAsyncComponent( async () =>
        //   await import('logrocket')
        // )

        // const LogRocket = async () => await import('logrocket');

        // const LogRocket = eval(require('logrocket'));

        // const LogRocket = await import('logrocket');

        // console.log("Logrocket IS: " + JSON.stringify(LogRocket, null, 2));

        // LogRocket.init('thanku-alt-4/thanku-alt-4'); //LogRocket.init('thanku-alt-3/thanku-alt-3');//LogRocket.init('thanku-alt-2/thanku-alt-2');//LogRocket.init('thanku-alt/tualt'); //LogRocket.init('fpi3vr/thanku');  //LogRocket.init('thanku-alt-10/thanku-alt-10'); //LogRocket.init('thanku-alt-9/thanku-alt-9'); //LogRocket.init('thanku-alt-8/thanku-alt-8'); //LogRocket.init("thanku-alt-7/thanku-alt-7"); //LogRocket.init('thanku-alt-6/thanku-alt-6'); //LogRocket.init('thanku-alt-5/thanku-alt-5'); //

        

        // console.log("ABLE TO INIT LOGROCKET!!!!!!!!!!!!!!!!!!!!");

        // LogRocket.identify(userObjectId, {
        //   name: LRDisplayname,
        //   email: undefined,
        //   // Add your own custom user variables here, ie:

        // });
      // } catch (e) {
      //   ////console.log("error starting LogRocket on App vue for user id: " + userObjectId);
        
      //   const params = {
      //     toEmail: "appalert@thanku.app",
      //     subject: "ALERT! LogRocket initialisation error: " + e.message,
      //     body: "ALERT! LogRocket initialisation error: " + e.message,
      //   };

      //   this.functionName = "sendEmail";
      //   this.paramsObject = params;
        
      //   this.loadParse = true;

      //   // fail silently do nothing
      // }
    },
    async getURLDataIfAnyAndSet(){

      console.log("PRE PRE PRESTARTING getURLDataIfAnyAndSet");

      let doingAsyncAction = false;

      try {

        console.log("STARTING getURLDataIfAnyAndSet");
        // get URL params
        let urlParams = new URLSearchParams(window.location.search);

        console.log("should have urlparams coming...");

        console.log("urlParams ON APP:: " + urlParams);

        let referrerURL = (document.referrer !== undefined && document.referrer !== null && document.referrer !== "") ? document.referrer : "n/a";
        window.localStorage.setItem("referrerURL", referrerURL);

        // console.log("on App.vue referrerURL is: " + referrerURL);

        // /////console.log(urlParams.has('tu')); // true

         if (urlParams.has('rgla')){
          if (urlParams.get('rgla') === "1"){

            
            // console.log("rgla = 1 SO doLoadLogRocket!!!!");

            let LRObjectId = undefined;

            if (window.localStorage.getItem("tuob") !== null) {
              LRObjectId = window.localStorage.getItem("tuob");
            } else if (window.localStorage.getItem("logRocketUserTimeStampId") !== null) {
              LRObjectId = window.localStorage.getItem("logRocketUserTimeStampId");
            } else {
              window.localStorage.setItem("logRocketUserTimeStampId", new Date().getTime());
              LRObjectId = window.localStorage.getItem("logRocketUserTimeStampId");
            }

            this.showHomePageFromGoogleAd = true;
            this.homeScreenToggle = !this.homeScreenToggle;

            if (window.localStorage.getItem("beenFromGoogleAdsAlready") !== null && window.localStorage.getItem("beenFromGoogleAdsAlready") === "yes") {

              let referrerURL = (document.referrer !== undefined && document.referrer !== null && document.referrer !== "") ? document.referrer : "n/a";
              window.localStorage.setItem("googleAdsOriginalReferrerURL", referrerURL);


              let numTimes = "0";

              if (window.localStorage.getItem("beenFromGoogleAdsAlreadyNumTimes") !== null){
                numTimes = +window.localStorage.getItem("beenFromGoogleAdsAlreadyNumTimes");
                numTimes += 1;
                window.localStorage.setItem("beenFromGoogleAdsAlreadyNumTimes", numTimes.toString());
              }

              let params = {
                toEmail: "appalert@thanku.app",
                subject: "NB, user from Google Ads reloaded / revisited page",
                body: {
                  type: "GoogleAdsRepeatTime",
                  numberOfTimes: numTimes,
                  googleAdsOriginalReferrerURL: window.localStorage.getItem("googleAdsOriginalReferrerURL"),
                  referrerURL: window.localStorage.getItem("referrerURL"),
                  LRObjectId: LRObjectId
                },
              };
              console.log("about to load PARSE 2");
              this.loadParse = false;
              this.loadParseToggle = !this.loadParseToggle;
              this.functionName = "sendEmail";
              this.paramsObject = params;
              this.loadParse = true;

            } else {
              // 'rgla' is referrer Google Ads

              // // https://googleads.g.doubleclick.net/ was an unreliable means of detection

              // referrerUrl local is set elsewhere
              window.localStorage.setItem("beenFromGoogleAdsAlready", "yes");
              window.localStorage.setItem("beenFromGoogleAdsAlreadyNumTimes", "1");

              let params = {
                toEmail: "appalert@thanku.app",
                subject: "user from Google Ads first time load",
                body: {
                  type: "GoogleAds1stTime",
                  numberOfTimes: 1,
                  referrerURL: window.localStorage.getItem("referrerURL"),
                  LRObjectId: LRObjectId
                },
              };
              console.log("about to load PARSE 1");
              this.loadParse = false;
              this.loadParseToggle = !this.loadParseToggle;
              this.functionName = "sendEmail";
              this.paramsObject = params;
              this.loadParse = true;
              this.showHomePageFromGoogleAd = true;
              this.homeScreenToggle = !this.homeScreenToggle;

              console.log("this.showHomePageFromGoogleAd: "+ this.showHomePageFromGoogleAd);
            }

          } else {
            this.showHomePageFromGoogleAd = false;
            this.homeScreenToggle = !this.homeScreenToggle;
          }
          
        } else {
          // this is the one which will be triggered
          this.showHomePageFromGoogleAd = false;
          this.homeScreenToggle = !this.homeScreenToggle;
        }
        

        if (urlParams.has('showlanding')){
          if (urlParams.get('showlanding') === "yes"){
            ////console.log("showing LANDING!");
            this.showLanding = true;
          }
        }

        if (urlParams.has('returnfromstripeonboarding')){
          if (urlParams.get('returnfromstripeonboarding') === "yes"){
            // console.log("returnfromstripeonboarding!");
            window.localStorage.setItem("returnfromstripeonboarding", "yes");
            this.bypassDashboard = true;
          }
        }

        if (window.localStorage.getItem("localIsDoingStripeOnboarding") != null) {
          // means the user might, for example, have simply clicked the back button on browser when presented with Stripe onboarding
          window.localStorage.removeItem("localIsDoingStripeOnboarding");
          if (window.localStorage.getItem("returnfromstripeonboarding") !== null){
            // no need to worry already doing it
          } else {
            // console.log("localIsDoingStripeOnboarding => returnfromstripeonboarding!");
            window.localStorage.setItem("returnfromstripeonboarding", "yes");
            this.bypassDashboard = true;
          }

        }

        if (urlParams.has('refreshstripeonboardinglink')){
          if (urlParams.get('refreshstripeonboardinglink') === "yes"){
            // console.log("refreshstripeonboardinglink!");
            window.localStorage.setItem("refreshstripeonboardinglink", "yes");
            this.bypassDashboard = true;
          }
        }

         if (urlParams.has('mustDoKYC')){
          if (urlParams.get('mustDoKYC') === "yes"){
            // console.log("mustDoKYC!");
            window.localStorage.setItem("mustDoKYC", "yes");
            this.bypassDashboard = true;
          }
        }

        // this is now being done in the router to stop component loading before redirect
        if (urlParams.has('linkname')){
          // console.log("we are doing this here LINKNAME");
          if (urlParams.get('linkname') === "ggreview"){
            doingAsyncAction = true;
            let params = {
              linkName: urlParams.get('linkname'),
              userObjectId: urlParams.get('tuob'),
            }
            this.loadParse = false;
            this.loadParseToggle = !this.loadParseToggle;
            this.functionName = "ggreview";
            this.paramsObject = params;
            this.loadParse = true;
            // sharedhome.doParseServer('ggreview', params, this.appId, this.appJSKey);
          }
        }

        if (urlParams.has('tu') && urlParams.has('tuob')){
          // migrating users need both
          // console.log("setting user details from link");
          
          // await this.deployLogRocket(urlParams.get('tuob')); TODO Put this back in

          let urlParams = new URLSearchParams(window.location.search);

          if (urlParams.has('tu') && urlParams.has('tuob')){

            if (urlParams.get("tuob") === "GJKuIWpV63") {
                const params = {
                  toEmail: "appalert@thanku.app",
                  subject: "Anouk got to link activation",
                  body: ""
                };

                this.loadParse = false;
                this.loadParseToggle = !this.loadParseToggle;
                this.functionName = "sendEmail";
                this.paramsObject = params;
                this.loadParse = true;

            } 
          }

          ////console.log("MIGRATING USER");
          doingAsyncAction = true;        
          let params = {
            tu: urlParams.get('tu'),
            tuob: urlParams.get('tuob'),
          }
          this.loadParse = false;
          this.loadParseToggle = !this.loadParseToggle;
          this.functionName = "validateUserLinkDetails";
          this.paramsObject = params;
          this.loadParse = true;

          ////console.log("deployed LogRocket");

          ////console.log("sending params: " + JSON.stringify(params, null, 2))

        } 
        
        if (doingAsyncAction === false) {
          this.doFinishLoading();
        }

      } catch (err) {
          console.log("ERROR in getURLDataIfAnyAndSet:: " + err.message);
          throw err;
      }
    },
    async getURLDataIfAnyAndSetPart2(returnJSON){

      let suppressMessage = "no";

      let selectUserData = returnJSON;

      console.log("THIS IS THE selectUserData: " + JSON.stringify(selectUserData, null, 2));

      

      //let urlParams = new URLSearchParams(window.location.search); won't work anymore already consumed

      //console.log("urlParams on getURLDataIfAnyAndSetPart2 are: " + JSON.stringify(urlParams, null, 2))

      try{

        // const selectUserData = await sharedhome.doParseServer('validateUserLinkDetails', params, this.appId, this.appJSKey);

        // console.log("retrieved selectedUserData:: " + JSON.stringify(selectUserData, null, 2));

        // /////console.log("match result: " + result);
        if (selectUserData.status === "ok") {

          // console.log("successfully activated user");

          ////console.log("selectUserData.suppressMessage: " + selectUserData.suppressMessage);
        
          if (selectUserData.suppressMessage !== "yes") {
            this.popUpMsgTitle = "Great news..";
            this.popUpMsgBody = "Your ThankU account has been successfully activated on this device";
            this.showPopUpOk = true;
            suppressMessage = "";
          } else {
            suppressMessage = "USER MESSAGE WAS SUPPRESSED - ";
          }
          
          let tuTemp = window.localStorage.getItem("tu");
          let tuobTemp = window.localStorage.getItem("tuob");

          window.localStorage.clear();

          window.localStorage.setItem("tu", tuTemp);
          window.localStorage.setItem("tuob", tuobTemp);
          window.localStorage.setItem("tudis", selectUserData.displayname);
          window.localStorage.setItem("tuisfulluser", true); // must be since we had a valid login session token
          window.localStorage.setItem("tuhasstconnaccid", (selectUserData.strConnAccId !== undefined));
          window.localStorage.setItem("tuhasryftconnaccid", (selectUserData.ryftConnAccId !== undefined));
          window.localStorage.setItem("tucurrcode", selectUserData.currencyCode);
          window.localStorage.setItem("tuhasstconnaccextid", (selectUserData.strConnAccExternalAccountId !== undefined));
          window.localStorage.setItem("tuhasryftconnaccextid", (selectUserData.ryftConnAccExternalAccountId !== undefined));
          window.localStorage.setItem("tuisrecipient", selectUserData.isRecipient);

          if (selectUserData.isRecipient === true) {

            if ((window.localStorage.getItem("tuhasstconnaccid") === null || window.localStorage.getItem("tuhasstconnaccextid") === null) && (window.localStorage.getItem("tuhasryftconnaccid") === null || window.localStorage.getItem("tuhasryftconnaccextid") === null)) {
              // this.showPlaceholderAccountPage = false;

              // console.log("mustConnectToBankAccount is firing, tuhasstconnaccid is " + window.localStorage.getItem("tuhasstconnaccid") + " and tuhasstconnaccextid is " + window.localStorage.getItem("tuhasstconnaccextid"));
              this.mustConnectToBankAccount = true;
            } else {
              // console.log("IS NOT FIRING");
            }

            // if (selectUserData.strConnAccId !== undefined) {
            //   window.localStorage.setItem("strConnAccId", selectUserData.strConnAccId);
            // }
          } else {
            // console.log("really not firing");
          }


          const params = {
            toEmail: "appalert@thanku.app",
            subject: suppressMessage + "Great! " + selectUserData.displayname + " id: "  + window.localStorage.getItem("tuob") + " activated their account on the web app",
            body: suppressMessage + "Great! " + selectUserData.displayname + " id: "  + window.localStorage.getItem("tuob") + " activated their account on the web app"
          };

          this.loadParse = false;
          this.loadParseToggle = !this.loadParseToggle;
          this.functionName = "sendEmail";
          this.paramsObject = params;
          this.loadParse = true;
          // sharedhome.doParseServer("sendEmail", params, this.appId, this.appJSKey);
          
          this.doFinishLoading();

          // /////console.log("Details: " + window.localStorage.getItem("tu") + " " + window.localStorage.getItem("tuob"));

        } else {
          ////console.log("couldn't activate user: " + e.message);

          let userObjectId = window.localStorage.getItem("tuob") ? window.localStorage.getItem("tuob") : "unknown Id";
          const params = {
            toEmail: "appalert@thanku.app",
            subject: "ALERT! couldn't activate QR user: " + userObjectId,
            body: "",
          };
          this.loadParse = false;
          this.loadParseToggle = !this.loadParseToggle;
          this.functionName = "sendEmail";
          this.paramsObject = params;
          this.loadParse = true;

          // sharedhome.doParseServer("sendEmail", params, this.appId, this.appJSKey);

          this.popUpMsgTitle = "Sorry";
          this.popUpMsgBody = "ThankU couldn't match your details from that link. Please copy the link and email it to tech@thanku.app. We apologise for the inconvenience.";
          this.showPopUpOk = true;

          this.doFinishLoading();
        }


      } catch (e) {
        throw e;
      }
    },
    doRedirects(){

      var currentRedirect = this.redirect;


      let urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get('tuid') === "00000001933"){
        this.redirectParam1 = "Body Image";
        this.redirect = "tipwithoutscanning";
        console.log("came through here :-)");
      }  

      console.log("START redirects:" + window.location.href + " op ");

      if (window.location.href.indexOf("/nhbfmembers") > -1){
        this.redirect = "nhbf"; // I was passing this instance var thorugh the prop to HomeContent :tuRedirect='this.redirect' - problem is that value of showHomeScreen starts as true, therefore the prop gest passed on creation
        this.showHomeScreen = true; 

      } else if (window.location.href.indexOf("/contactnew") > -1) {
        this.redirect = "contactnew";
      } else if (window.location.href.indexOf("/aboutnew") > -1) {
        this.redirect = "aboutnew";
       } else if (window.location.href.indexOf("/termsnew") > -1) {
        this.redirect = "termsnew";
      } else if (window.location.href.indexOf("/privacynew") > -1) {
        this.redirect = "privacynew"
      } else if (window.location.href.indexOf("/givetipsmoreinfonew") > -1) {
        this.redirect = "givetipsmoreinfonew";
      } else if (window.location.href.indexOf("/gettipsmoreinfonew") > -1) {
        this.redirect = "gettipsmoreinfonew";
      } else if (window.location.href.indexOf("/gettipsstartnew") > -1) {
        console.log("SHOULD gettipsstartnew");
        this.redirect = "gettipsstartnew";
        this.homeScreenToggle = !this.homeScreenToggle;
      } else if (window.location.href.indexOf("/contact") > -1) {
        this.redirect = "contact";
      } else if (window.location.href.indexOf("/about") > -1) {
        this.redirect = "about";
      } else if (window.location.href.indexOf("/terms") > -1) {
        this.redirect = "terms";
      } else if (window.location.href.indexOf("/privacy") > -1) {
        this.redirect = "privacy";
      } else if (window.location.href.indexOf("/givetips") > -1) {
        this.redirect = "givetips";
      } else if (window.location.href.indexOf("/givetipsmoreinfo") > -1) {
        this.redirect = "givetipsmoreinfo";
      } else if (window.location.href.indexOf("/tipwithoutscanning") > -1) {
        this.redirect = "tipwithoutscanning";

      } else if (window.location.href.indexOf("/gettipsstart") > -1) {
        // NB this must come before gettips otherwise that will be found incorrectly first
        this.redirect = "gettipsstart";

      } else if (window.location.href.indexOf("/gettips") > -1) {
        this.redirect = "gettips";
     
      } else if (window.location.href.indexOf("/gettipsmoreinfo") > -1) {
        this.redirect = "gettipsmoreinfo";
      } else if (window.location.href.indexOf("/testimonials") > -1) {
        this.redirect = "testimonials";
      } else if (window.location.href.indexOf("/salons") > -1) {
        ////console.log("REDIRECT TO SALONS!" );
        this.redirect = "salons";
      } else if (window.location.href.indexOf("/unsubscribe") > -1) {
        ////console.log("REDIRECT TO unsubscribe!" );

        let urlParams = new URLSearchParams(window.location.search);

        ////console.log("urlParams: " + JSON.stringify(urlParams, null, 2));

        if (urlParams.has('em')){
          let email = urlParams.get('em');
          window.localStorage.setItem("emailToUnsubscribe", email);
        }

        this.redirect = "unsubscribe";
      }

      if (currentRedirect === this.redirect) {
        console.log("returning false");
        return false;
      } else {
        console.log("returning true");
        return true;
      }


    }, 
    getUserDataIfNecessary(){


      // console.log("starting getUserDataIfNecessary"); 

      let urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has('tu') && urlParams.has('tuob')){

        if (urlParams.get("tuob") === "GJKuIWpV63") {
            const params = {
              toEmail: "appalert@thanku.app",
              subject: "Anouk got to getUserDataIfNecessary",
              body: ""
            };

            this.loadParse = false;
            this.loadParseToggle = !this.loadParseToggle;
            this.functionName = "sendEmail";
            this.paramsObject = params;
            this.loadParse = true;

        } 
      }


      // this is to refresh expected user values in case the user logged in etc before a given value starting being required by the front end code
      try {
        if (window.localStorage.getItem("tuob") !== null && window.localStorage.getItem("tuisfulluser") !== null) {

          // ////console.log("getUserDataIfNecessary tuob::: " + window.localStorage.getItem("tuob"));
          // we have a proper user, check they have all the object values they should
          if (window.localStorage.getItem("tuisrecipient") === null || window.localStorage.getItem("tuisrecipient") === undefined || window.localStorage.getItem("tuisrecipient") === "undefined" ) {

            // console.log("getUserDataIfNecessary tuisrecipient was null");

            let params = {
              userObjectId: window.localStorage.getItem("tuob"),
            }
            this.loadParse = false;
            this.loadParseToggle = !this.loadParseToggle;
            this.functionName = "fetchUserDetails";
            this.paramsObject = params;
            this.loadParse = true;

            // takes us off into async situation

            // const userData = await sharedhome.doParseServer("fetchUserDetails", params, this.appId, this.appJSKey);
            
          } else {

            // console.log("getUserDataIfNecessary tuisrecipient was NOT null");

            // can go straight on
            this.doPostGetUserDataIfNecessary();

            ////console.log("getUserDataIfNecessary ELSE::: " );
            // this.popUpMsgTitle = "Great";
            // this.popUpMsgBody = "isRecipient:: " + window.localStorage.getItem("tuisrecipient");
            // this.showPopUpOk = true;
          }
          // return true; // doesnt do anything now
        } else {
          // console.log("condition not met");
          this.doPostGetUserDataIfNecessary();
        }


      } catch (e) {
        this.popUpMsgTitle = "Oops";
        this.popUpMsgBody = "ThankU ran into a problem: " + e.message + " in getUserDataIfNecessary. Please copy this message and email it to tech@thanku.app. We apologise for the inconvenience.";
        this.showPopUpOk = true;
      }
    },
    doPostGetUserDataIfNecessary(){

      // console.log("doPostGetUserDataIfNecessary yup");

      this.getURLDataIfAnyAndSet(); // no longer is an await because async doesn't work with considtional Parse loading

    },  
  
    doFinishLoading(){

      // if (window.localStorage.getItem('tuob') !== undefined){

      //   if (window.localStorage.getItem('tuob') === "GJKuIWpV63") {
      //       const params = {
      //         toEmail: "appalert@thanku.app",
      //         subject: "Anouk got to doFinishLoading",
      //         body: ""
      //       };

      //       this.loadParse = false;
      //       this.loadParseToggle = !this.loadParseToggle;
      //       this.functionName = "sendEmail";
      //       this.paramsObject = params;
      //       this.loadParse = true;

      //   } 
      // }


      // separate end section because  we can get to it in two different ways, getURLDataIfAnyAndSet and getURLDataIfAnyAndSetPart2
      if (window.localStorage.getItem("willConnectRealUserDetails") !== null) {

        if (window.localStorage.getItem("willConnectRealUserDetailsinprocess") !== null) {
          // 
          // console.log("willConnectRealUserDetailsinprocess WAS NOT NULL");

          window.localStorage.setItem("tuconnecttovenue", "bankAccountOnly"); // in testing we lost it somewhere

          this.showingProceedWithVenueConnectMessage = true;
          this.PopUpTwoOptionsTitle = "Continue setting up?";
          this.PopUpTwoOptionsMessage = "You were in the process of setting up your ThankU account. Tap 'Connect' to complete the process or 'No thanks' otherwise. You can restart the process anytime by scanning your ThankU QR code."; // different message because they are already connected
          this.option1ButtonText = "Connect";
          this.option2ButtonText = "No thanks";
          this.showHomeScreen = false;
          this.showPopUpTwoOptions = true;
        } else {
          // /////console.log("showing Account because of willConnectRealUserDetails");
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 9");
        }

      } else if (window.localStorage.getItem("tuconnecttovenue") !== null && window.localStorage.getItem("tuconnecttovenue") !== "bankAccountOnly") {

        if (window.localStorage.getItem("tuconnecttovenueinprocess") !== null) {
          
          // console.log("tuconnecttovenueinprocess WAS NOT NULL");

          this.showingProceedWithVenueConnectMessage = true;
          this.PopUpTwoOptionsTitle = "Continue connecting?";
          const venueName = window.localStorage.getItem("tuconnecttovenuename") !== null ? " at " + window.localStorage.getItem("tuconnecttovenuename") : "";
          this.PopUpTwoOptionsMessage = "You were in the process of connecting your ThankU account" + venueName + ". Tap 'Connect' to complete the process or 'No thanks' otherwise. You can restart the process anytime by scanning one of the ThankU QR badges where you work and tapping 'Get tips here...' at the bottom of the list.";
          this.option1ButtonText = "Connect";
          this.option2ButtonText = "No thanks";
          this.showHomeScreen = false;
          this.showPopUpTwoOptions = true;

          // the purpose of below is to ensure when we are analysing missed tips that this is not picked up as one since it indicates the user was trying to become a recipient. We had an instance where they simply stopped here without tapping any buttons 

          let params = {
            userObjectId: window.localStorage.getItem("tuob"),
            userLikelyToBeRecipient: true,
          }
          this.loadParse = false;
          this.loadParseToggle = !this.loadParseToggle;
          this.functionName = "saveUserFromWebApp";
          this.paramsObject = params;
          this.loadParse = true;
          console.log("ran saveUserFromWebApp for user " + window.localStorage.getItem("tuob"));
          
        } else {
          // /////console.log("showing Account because of tuconnecttovenue");
          this.showHomeScreen = false;
          this.showAccount = true;
          console.log("HERE 10");
        }
      } else if (window.localStorage.getItem("tuisrecipient") !== null && this.tuid === undefined){ // not a tuid link
          console.log("I am a recipient: " + window.localStorage.getItem("tuisrecipient"));

          // if (window.localStorage.getItem('tuob') !== undefined){

          //   if (window.localStorage.getItem('tuob') === "GJKuIWpV63") {
          //       const params = {
          //         toEmail: "appalert@thanku.app",
          //         subject: "Anouk got to direction to load Dashboard",
          //         body: ""
          //       };

          //       this.loadParse = false;
          //       this.loadParseToggle = !this.loadParseToggle;
          //       this.functionName = "sendEmail";
          //       this.paramsObject = params;
          //       this.loadParse = true;

          //   } 
          // }

          if (this.reloading === false) {
            this.showHomeScreen = false;
            this.showAccount = true;
            console.log("HERE 1");
          }
      }
    },
  },

  async created(){

    let networkMsgBoxTimeoutId = setTimeout(function() {
      document.getElementById('networkMsgBox').style.display = ''; // Set to default or you can explicitly set 'block' if it's a block element
      console.log("networkMsgBox is now visible"); 
    }, 1500); // 1000 milliseconds = 1 second

    window.localStorage.setItem("networkMsgBoxTimeoutId", networkMsgBoxTimeoutId);

    let urlParams = newFunction();

    if (urlParams.has('tu') && urlParams.has('tuob')){

      if (urlParams.get("tuob") === "GJKuIWpV63") {
          const params = {
            toEmail: "appalert@thanku.app",
            subject: "Anouk got to app created",
            body: ""
          };

          this.loadParse = false;
          this.loadParseToggle = !this.loadParseToggle;
          this.functionName = "sendEmail";
          this.paramsObject = params;
          this.loadParse = true;

      }  
    }
    // console.log("this.devEnv::::::::::::::::", this.devEnv);
    // console.log("this.appId::::::::::::::::", this.appId);

    // console.log("this.fromScreenAPP: " + this.fromScreen);
    
    if (window.localStorage.getItem("tuob") !== null & window.localStorage.getItem("tuob") === "M1t7NvDnNd"){
      window.localStorage.removeItem("tuob"); // account deleted (Nicola accidental at Total Hair Concept)
    }

    if (window.localStorage.getItem("tuob") !== null & window.localStorage.getItem("tuob") === "FFPgaN56n9"){
      window.localStorage.removeItem("tuob"); // account deleted (Rosamund accidental at HARI's South Ken)
    }

    if (window.localStorage.getItem("tuob") !== null & window.localStorage.getItem("tuob") === "QgFSN60KjX"){
      window.localStorage.removeItem("tuob"); // account deleted (Gintare) accidental sign up at Edward James Balham
    }

    if (window.localStorage.getItem("tuob") !== null & window.localStorage.getItem("tuob") === "UorgmuYUlM"){
      window.localStorage.removeItem("tuob"); // 'Talky' didnt want an acount, just to tip..
    }
    
    if (window.localStorage.getItem("tuob") !== null){
      ////console.log("CREATED!!! with " + window.localStorage.getItem("tuob"));
    }

    if (this.doRedirects() === true){ // need to do this first before everything has loaded. Prop only gets passed at creatTime - not even sure why this actually is working - alternative strategy to use localStorage
      ////console.log("we redirected");
      return;
    } else {
      ////console.log("NO REDIRECTS HERE!");
    }


    ////console.log("created about to getTUID");
    this.getTUID();
    ////console.log("CREATED about to getUserDataIfNecessary");

    let myREALParams = new URLSearchParams(window.location.search);
    // console.log("myREALParams: " + myREALParams);

    this.getUserDataIfNecessary();  // can no longer be await because of the conditional Parse load everythign has to happen in sequence

    function newFunction() {
      return new URLSearchParams(window.location.search);
    }
   

  }, 
  async mounted(){

    // alert("APP " + window.localStorage.getItem("willConnectRealUserDetails"));
   
    // this.loadParse = true;

    // window.addEventListener("scroll", this.doLoadParse);
    
    // window.setTimeout(this.doLoadParse, 5000);
  },
}
</script>

<style>

/* @font-face {
    font-family: "DIN Next LT Pro";
    src: local("LT"), 
      url(./fonts/DINNextLTPro-Regular.ttf) format("truetype");
    font-weight: normal;
    font-style: normal;
}
*/

/* this is actually operating */
#app { 
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.25px;
  color: #000066;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  margin-top: 60px;
  
}

/* button { */
  /* ok amazingly I had never set the border style anywhere in the app and was using the brower's default, and the default in Chrome at least is shown below. But since I haven't needed it until now I am going to leave it and apply only when needed*/
  /* border: 2px outset rgba(118, 118, 118, 0.3); /* Set the thickness and style of the border as needed */
/* } */

.networkmsg {
  max-width: 200px;
  margin: auto;
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.25px;
  color:#333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* display: flex; */
  align-items: center; /* Vertically center the content */
  justify-content: center; /* Horizontally center the content */
  /*height: 100vh; /* Take up the full height of the viewport */
  
}

/* NEW THANKU STYLES WHICH WERE MOVED FROM HOME.APP SO THAT THEY WOULD OPERATE PROPERLY ON BACKBUTTON WHICH DIDN'T TAKE THE ROUTE BACK VIA HOME.APP - start */
/* NEW TU STYLE SECTION FOR HOME PAGE */

/* // Extra small devices (portrait phones, less than 576px) THIS DOES MY IPHONE 12 IN PORTRAIT*/  
@media (max-width: 575.98px) { 

  .mediaSelectDesktop {
    display: none;
  }
  .mediaSelectPhone {
    display: normal;
  }
  .wrapper-todiv {
    margin: auto;
    width: 91%;
    min-width: 50px; /* Will be AT LEAST 20em wide */
    max-width: 400px; 
    /* background: rgb(207, 54, 156); */
    z-index: 501;
    background-color: transparent;
    /* outline:0.01em solid black;    */
  }
  /* this is only required for desktop sizing see note below, that is why on mobile the settings are the same */
  .wrapper-todiv-new {
    margin: auto;
    width: 91%;
    min-width: 50px; /* Will be AT LEAST 20em wide */
    max-width: 400px; 
    /* background: rgb(207, 54, 156); */
    z-index: 501;
    background-color: transparent;
    /* outline:0.01em solid black;    */
  }


  .tugradient1{
	  background: linear-gradient(90deg, #EDF2F7 0%, #fff 30%,  #fff 45%, #EDF2F7 90%)  !important;
  }
  .tutitlefontsize {
    font-size: clamp(30px, 10vw, 38px);
    font-weight: bold;
  }
  .tumediumtitlebold {
    font-weight: bold;
    font-size: clamp(10px, 7vw, 18px);
  }
  .tumediumtitleboldbigger {
    font-weight: bold;
    font-size: clamp(12px, 8vw, 24px);
  }
  .turegularfontsize {
    font-size: clamp(10px, 3vh, 14px);
  }
  .tusmallerfontsize {
    font-size: clamp(6px, 2vh, 12px);
  }
  .tusmallestfontsize {
    font-size: clamp(6px, 2vh, 10px);
  }
  .highestratedpadding{
    padding-top: 1vw;
    padding-bottom: 2vw;
  }
  .tunavbarlogoheight{
    height: clamp(30px, 12vw, 50px);
  }
  .mainimageheight {
    height: auto;
  }
  .mainimagewidth {
    width: 80%;
  }
 
  .tusmileimagedims {
    height: 35px;
    width: 35px;
  }

  .smile1 {
    display: none;
    width: 0px; 
    margin-top:10px; 
    z-index: 1; 
    margin-left:-15px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }

  .smile2 {
    display: none;
    width: 80px; 
    margin-top:-30px; 
    margin-right:-340px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }
  .smile3 {
    display: none;
    width: 120px; 
    margin-top:-30px; 
    z-index: 1; 
    margin-left:-350px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }

  .smile4 {
    display: none;
    width: 160px; 
    margin-top:250px; 
    margin-right:-320px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }

  .smile5 {
    display: none;
    width: 100px; 
    margin-top:70px; 
    z-index: 1; 
    margin-left:-370px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }


  .tubestsolutiontitle{
    padding-left: 3vw; 
    padding-right: 3vw; 
    padding-top:3vw; 
  }
  .maintextpadding {
    padding-left: 3vw !important;
    padding-right: 6vw !important;
    padding-top: 1vh !important;
    padding-bottom: 1vh !important;
  }
  .tucarousel__itembrands {
    min-height: 120px;
    width: 30%;
    color: var(--vc-clr-black);
    font-size: 20px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tucarousel__itemtestimonials {
    min-height: 180px;
    width: 70%;
    color: var(--vc-clr-black);
    font-weight: normal;
    font-size: clamp(10px, 2vh, 16px);
    border-radius: 8px;
    justify-content: center;
    align-items: center;
  }

  .tucarousel__itemtestimonialsimgsettingsstars {
    width: 40%;
  }

  .tucarousel__itemtestimonialsimgsettings {
    width: 32%;
  }

  .tucarousel__itemtestimonialsparatestimonial {
    margin-top: clamp(6px, 2vw, 16px);
    margin-bottom: clamp(6px, 3vw, 16px);
    font-weight: normal;
    font-size: clamp(10px, 3vw, 12px);
    height: 70px;
    max-height: 70px;
  }

  .tucarousel__itemtestimonialsparaattributed {
    margin-bottom: clamp(6px, 4vw, 16px);
    font-weight: normal;
    font-size: clamp(10px, 3vw, 12px);
  }

  .tucarouselpadding {
    padding-left: 0vw; 
    padding-right: 0vw; 
  }

  .tuparachunkpadding{
    padding-top: 1vh; 
    padding-bottom: 1vh; 
    padding-left: 3vh; 
    padding-right: 3vh;
  }

  .tutablepadding {
    padding-left: 0px; 
    padding-right: 0px; 
  }

  .tuiconpadding {
    padding-left: 0.3vw; 
    padding-right: 0.3vw; 
  }

  .tufooterpadding {
    padding-left: 3vw; 
    padding-right: 3vw; 
  }

  .tuhomepagesignupbutton {
    height: 9vw;
    width: 60%;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 0.3vw;
    padding-bottom: 0.3vw;
    border-radius: 4px;
    border-width: 1px;
    background: #000067;
    cursor: pointer;
    font-weight: 200;
    letter-spacing: 0.55px;
    color: #FFFFFF;
  }

  .tuhomepagebutton {
    height: 9vw;
    width: 70%;
    padding-left: 6vw;
    padding-right: 6vw;
    padding-top: 0.3vw;
    padding-bottom: 0.3vw;
    border-radius: 4px;
    border-width: 1px;
    background: #95AEED;
    cursor: pointer;
    font-weight: 200;
    letter-spacing: 0.55px;
    color: #FFFFFF;
  }
  .bottombuttonwidth{
    width: 70%
  }

  .tuwhitebox {
    padding-top: 2vw;
    padding-bottom: 2vw;
    border-radius: 20px;
    background: #ffffff;
    filter: drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  .tuwhiteboxlist {
    padding-top: 1vw;
    padding-bottom: 1vw;
    border-radius: 7px;
    background: #ffffff;
    filter: drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  .tugreybluebox {
    padding-top: 2vw;
    padding-bottom: 2vw;
    border-radius: 20px;
    background: #EDF2F7;
    filter: drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  .infobtn {
    border-radius: 10px;
    border:1px solid #000066;
    position: relative;
    width: 100%;
    height: 90%;
    left: 0px;
    top: 0px;
    background: #FFFFFF;
    cursor:pointer;
    filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  .text-only-button-new{
    font-family: "LT", Helvetica, Arial;
    font-style: bold;
    text-align: center;
    border: none;
    outline: none; 
    padding: 30;
    background: none; 
    cursor:pointer;
    color: #000066;  
  }

}

/* // Small devices (landscape phones, 576px and up) THIS DOES MY IPHONE 12 IN LANDSCAPE, AND DESKTOP*/
/*  * @media (min-width: 576px) and (max-width: 767.98px) {  */
@media (min-width: 576px) { 

  .mediaSelectDesktop {
    display: normal;
  }
  .mediaSelectPhone {
    display: none !important;
  }
 /*  we now need two versions of wrapper-todiv to account for the two screen sizes we are catering for */

   .wrapper-todiv {
    margin: auto;
    width: 91%;
    min-width: 50px; /* Will be AT LEAST 20em wide */
    max-width: 400px; 
    /* background: rgb(207, 54, 156); */
    /* below higher than for mobile to get over Navbar */
    z-index: 998;
    background-color: transparent;
    /* outline:0.01em solid black;    */
  }
  /* the following is needed because in principle we need old and new designs to work simultaneouly. If app is in desktop mode and showOld is true, then we need the settings below to apply to make the transparent backgroud across the whole screen. You will see this in effect from logging in from the home page and then logging out*/
  .wrapper-todiv-new {
    margin: auto;
    /* width: 91%; */
    min-width: 50px; /* Will be AT LEAST 20em wide */
    /* max-width: 400px;  */
    /* background: rgb(207, 54, 156); */
    /* below higher than for mobile to get over Navbar */
    z-index: 998;
    background-color: transparent;
    /* outline:0.01em solid black;    */
  }
  
  .tugradient1{
    background: linear-gradient(90deg, #EDF2F7 0%, #fff 60%,  #fff 65%, #EDF2F7 85%)  !important;
  }
  .tutitlefontsize {
    font-size: clamp(20px, 4vw, 38px);
    font-weight: bold;
  }

  .tumediumtitlebold {
    font-weight: bold;
    font-size: clamp(16px, 4vw, 22px);
  }

  .turegularfontsize {
    font-size: clamp(10px, 2vw, 16px);
  }
  .tusmallerfontsize {
    font-size: clamp(6px, 2vw, 15px);
  }
  .tusmallestfontsize {
    font-size: clamp(6px, 2vw, 12px);
  }

  .tunavbarlogoheight{
    height: clamp(50px, 8vw, 64px);;
  }
  
  .mainimageheight {
    height: 50px;
  }
  .mainimagewidth {
    width: 100%;
  }

  .tusmileimagedims {
    height: auto;
    width: 10vw;
  }
  .smile1 {
    width: 440px; 
    margin-top:-250px; 
    z-index: 1; 
    margin-right:-1100px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }

  .smile2 {
    width: 240px; 
    margin-top:0px; 
    margin-right:-1120px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }
  .smile3 {
    width: 340px; 
    margin-top:-80px; 
    z-index: 1; 
    margin-left:-850px; 
    opacity:0.02;
    filter:alpha(opacity=2);
  }

  .smile4 {
    width: 220px; 
    margin-top:130px; 
    margin-right:-700px; 
    opacity:0.03;
    filter:alpha(opacity=3);
  }

  .smile5 {
    width: 580px; 
    margin-top:-50px; 
    margin-left:-900px; 
    opacity:0.02;
    filter:alpha(opacity=2);
  }
  .tubestsolutiontitle{
    padding-left: 3vw; 
    padding-right: 3vw; 
    padding-top: 0vw; 
  }

  .maintextpadding {
    padding-left: 3vw !important;
    padding-right: 6vw !important;
    padding-top: 1vh !important;
    padding-bottom: 1vh !important;
  }
  .tucarousel__itembrands {
    min-height: 200px;
    width: 35%;
    color: var(--vc-clr-black);
    font-size: 20px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tucarousel__itemtestimonials {
    min-height: 350px;
    width: 80%;
    color: var(--vc-clr-black);
    font-weight: normal;
    font-size: 20px;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
  }

  .tucarousel__itemtestimonialsimgsettingsstars {
    width: 40%;
  }
  .tucarousel__itemtestimonialsimgsettings {
    width: 40%;
  }

  .tucarousel__itemtestimonialsparatestimonial {
    margin-top: 0.5vw;
    margin-bottom: 0.5vw;
    font-weight: normal;
    font-size: clamp(10px, 3vw, 12px);
    height: 80px;
    max-height: 80px;
  }

  .tucarousel__itemtestimonialsparaattributed {
    margin-bottom: 0.5vw;
    font-weight: normal;
    font-size: clamp(10px, 3vw, 12px);
  }

  .tucarouselpadding {
    padding-left: 3vw; 
    padding-right: 3vw; 
  }

  .tuparachunkpadding{
    padding-top: 1vh; 
    padding-bottom: 1vh; 
    padding-left: 20vh; 
    padding-right: 20vh;
  }


  .tutablepadding {
    padding-left: 0vw; 
    padding-right: 0vw; 
  }

  .tuiconpadding {
    padding-left: 0.1vw; 
    padding-right: 0.1vw; 
  }

  .tufooterpadding {
    padding-left: 0px; 
    padding-right: 0px; 
  }

  
  .tuhomepagesignupbutton {
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 0.3vw;
    padding-bottom: 0.3vw;
    border-radius: 4px;
    border-width: 1px;
    background: #000067;
    cursor: pointer;
    font-weight: 200;
    letter-spacing: 0.55px;
    color: #FFFFFF;
  }

  .tuhomepagebutton {
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 0.3vw;
    padding-bottom: 0.3vw;
    border-radius: 4px;
    border-width: 1px;
    background: #95AEED;
    cursor: pointer;
    font-weight: 200;
    letter-spacing: 0.55px;
    color: #FFFFFF;
  }

  .bottombuttonwidth{
    width: 50%
  }


  .tuwhitebox {
    padding-top: 2vw;
    padding-bottom: 2vw;
    border-radius: 20px;
    background: #ffffff;
    filter: drop-shadow(0px 1px 25px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  .tuwhiteboxlist {
    padding-top: 1vw;
    padding-bottom: 1vw;
    border-radius: 7px;
    background: #ffffff;
    filter: drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  
  .tugreybluebox {
    padding-top: 2vw;
    padding-bottom: 2vw;
    border-radius: 20px;
    background: #EDF2F7;
    filter: drop-shadow(0px 1px 25px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }
    .infobtn {
    border-radius: 10px;
    border:1px solid #000066;
    position: relative;
    width: 95%;
    height: 90%;
    left: 0px;
    top: 0px;
    background: #FFFFFF;
    cursor:pointer;
    filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
  }

  .text-only-button-new{
    font-family: "LT", Helvetica, Arial;
    font-style: bold;
    text-align: center;
    border: none;
    outline: none; 
    padding: 30;
    background: none; 
    cursor:pointer;
    color: #000066;  
  }

}

.tubackcolour{
    background: #EDF2F7  !important;
}



/* .tugradient1 {
  background: linear-gradient(90deg, #EDF2F7 0%, #fff 60%,  #fff 65%, #EDF2F7 70%) !important;
}; */






.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid rgb(179, 22, 22);
}


/* END NEW TU STYLE SECTION FOR HOME PAGE */
/* NEW THANKU STYLES WHICH WERE MOVED FROM HOME.APP SO THAT THEY WOULD OPERATE PROPERLY ON BACKBUTTON WHICH DIDN'T TAKE THE ROUTE BACK VIA HOME.APP - end */

.actionbtn-div {
  padding-top: clamp(2px, 2.5vh, 24px);
  /* padding-bottom: clamp(2px, 2vh, 18px); */
}
.actionbtn {

  border-radius: 10px;
  border:1px solid #000066;
  position: relative;
  width: 95%;
  height: 90%;
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  cursor:pointer;

  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  /* or 117% */

  letter-spacing: 0.35px;

  color: #000066;
  /* Box Shadow // Medium */

  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
}

/* NEW THANKU STYLES WHICH WERE ALWAYS LOCATED ON APP.VUE - start */

/* .bg-primary {
    background: #95AEED;
}  */

.background{
    background-color: #EDF2F7;  
}
/* background-color: #E5E5E5; */



.tufont {
  font-family: Arial, Helvetica, sans-serif;
  color:#333;
}

.tufontlightgrey {
  font-family: Arial, Helvetica, sans-serif;
  color:#868686;
}

.tublue {
  color: #000067;
}


.tulogo{
  position: relative;
  height: clamp(2px, 7vh, 64px);
  align-content: center;
  cursor:pointer;
}


/* NEW THANKU STYLES WHICH WERE ALWAYS ON VUE.APP - end */

/* EXISTING THANKU STYLES START */

.poweredbystripe{
  /* position: relative; */
  width: 35%;
  align-content: center;
}


.primary-text-title{
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 35px;
  align-items: center;
  letter-spacing: 0.25px;
  color: #000066;
}

.lt-blue{
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.25px;
  color: #000066;
}

.divl{
  text-align: left;
}

.divc{
  text-align: center;
}

.divr{
  text-align: right;
}

.tb-padding{
  padding-top: 1vh;
  padding-bottom: 1vh;
}

.txtl{
  align-items: left;
}

.txtc{
  align-items: center;
}

.txtr{
  align-items: right;
}


.primarytextmid{
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.35px;
  color: #000066;
}

.primarytextmidcentre{
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  align-items: center;
  letter-spacing: 0.35px;
  color: #000066;
}

.primary-general-text{
  font-family: "LT", Helvetica, Arial;
  font-style: bold;
  font-weight: normal;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.35px;
  color: #000066;   /* 000066 */
}

.notes-text{
  font-size: 12px;  
  width: 90%; 
  margin: 0 auto; 
  line-height: 15px;
  padding-top: 1vh;
  padding-bottom: 1vh;
}

.text-only-button{
  font-family: "LT", Helvetica, Arial;
  font-style: bold;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  border: none;
  outline: none; 
  padding: 30;
  background: none; 
  cursor:pointer;
  color: #000066;  
}



.cancel{
  font-family: "LT", Helvetica, Arial;
  font-style: bold;
  letter-spacing: 0.35px;
  padding: 0;
  color: #95AEED;
}

.padded{
  font-family: "LT", Helvetica, Arial;
  font-style: bold;
  letter-spacing: 0.35px;
  padding: 30;
  color: #95AEED;
}

.userinfoframe {
  position: relative;
  width: 100%;
  /* height: 80px; */
  display: flex;
  /* WIDTH and HEIGHT are required */
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border-radius: 20px;
}

.userinfoframelasttipped {
  position: relative;
  width: 100%;
  /* height: 80px; */
  display: flex;
  /* WIDTH and HEIGHT are required */
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border-radius: 20px;
  border:2px solid #c7dbfa; 
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}
  

.userinfoframenowidth {
  position: relative;
  /* height: 80px; */
  display: flex;
  /* WIDTH and HEIGHT are required */
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border-radius: 20px;
}

.infolabel {
  margin: auto;
  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 4vh;
  width: 100%;
  min-width: 50px;
  max-width: 440px;
  background: #E2E8F0; /* background: #E2E8F0; */
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.408px;
  color: #000066;
  border-radius: 10px

}

.tipbuttonsframe {
  position: relative;
  width: 100%;
  height: 30vh;
  display: flex;
  /* WIDTH and HEIGHT are required */
  justify-content: center;
  align-items: center;
}

.tipwidebuttonframe {
  position: relative;
  width: 100%;
  height: 10vh;
  
  display: flex;
  /* WIDTH and HEIGHT are required */
  justify-content: center;
  align-items: center;
  
}

.username {
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.35px;
  color: #1A202C;
}

.businessname{

  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 147% */

  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.35px;

  /* Text // Secondary */

  color: #718096;

}

.topcontent-div {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 0;
  /* background: rgb(209, 199, 56); */
}



/* 70% and 77% worked but buttons were too narrow on phone */

.wrapper-buttonsdiv {
  margin: auto;
  width:100%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 440px;
}


.btn {
  border-radius: 15px;
  position: relative;
  width: 90%;
  height: 12vh;
  left: 0px;
  top: 0px;
  background: #95AEED;

  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 2.5vh;
  /* or 117% */

  letter-spacing: 0.35px;

  color: #FFFFFF;
  /* Box Shadow // Medium */

  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
}

.currencySymbol{
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  letter-spacing: 2.00px;
}

.currencySymbolOtherAmount{
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
    /* border:1px solid #c2b43d; */
  color: #758CE0;
}
.currEquiv{
    letter-spacing: 0.35px;
    color: #D4DEF8;
    font-size: 16px;
}

.widebtn {
  border-radius: 15px;
  position: relative;
  width: 95%;
  height: 90%;
  left: 0px;
  top: 0px;
  background: #95AEED;
  cursor:pointer;

  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  /* or 117% */

  letter-spacing: 0.35px;

  color: #FFFFFF;
  /* Box Shadow // Medium */

  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
}

.widetipbtnon {
  border-radius: 15px;
  position: relative;
  width: 95%;
  height: 90%;
  left: 0px;
  top: 0px;
  background: #95AEED;
  cursor:pointer;

  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  /* or 117% */

  letter-spacing: 0.35px;

  color: #FFFFFF;
  /* Box Shadow // Medium */

  filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06));
}

.widetipbtnoff {
  border-radius: 15px;
  position: relative;
  width: 95%;
  height: 90%;
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  cursor: normal;

  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  /* or 117% */

  letter-spacing: 0.35px;
  border: 2px solid rgba(118, 118, 118, 0.3); /* although on Chrome this would be computed on Safari Mobile the inference if a button is disabled is that the default border turns to none*/

  /* color: #333333; actually the browser does a better job and makes it a more effacting light grey when the button is disabled */
  /* Box Shadow // Medium */

  /* filter: drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.06)); */
}

.searchinput {
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  letter-spacing: 0.35px;
  padding-left: 30px;
  height: 4vh;
  /* unusual Vue quirk meant that background-image would either have to be computed value or due it with inline style as per above */
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: left center;
  background-color: transparent;
  border:2px solid #b9b9c0; 
  border-radius: 7px;
}

.searchinputvibrant {
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  letter-spacing: 0.27px;
  padding-left: 30px;
  height: 5vh;
  /* unusual Vue quirk meant that background-image would either have to be computed value or due it with inline style as per above */
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: left center;
  background-color: white;
  border:2px solid #1a8bfc; 
  /* was #b9b9c0; */
  border-radius: 7px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
}


.other-amount-input {
  height: 10vh;
  /* width: 4%; */
  padding-left: 0;
  padding-right: 0;
  /* border:1px solid #c2b43d; */

  border: none;
  outline: none; 
  background: none; 


  font-size: 40px;
  
  text-decoration: underline;
  text-decoration-color: #758CE0;
  text-decoration-thickness: 2px;
  text-underline-offset: 6px;
  /* in Arjun's design, he shows a bigger offset which is nice, but unless you set a much greater line height it ceases to be visible, and if you do, then the vertical alignment goes out in safari mobile */
  /* line-height: 80px;   have to set this with a generous margin because we have offset the underline so far down otherwise it gets clipped */

    /* border:2px solid #b9b9c0; */
  /* border-radius: 7px; */
}

/* gets rid of up down arrows on input box number*/
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* gets rid of up down arrows on input box number*/
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.centreverticaldivsearch {
  height: 8vh;
  width: 65%;
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
}

.centreverticaldivsearchvibrant {
  height: 12vh;
  width: 85%;
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
}

.paymentform {
  position: relative;
  margin: auto; 
  width:90%; 
  outline:0.01em solid black; 
  height: 40vh
}

/* .topspacer { */
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30vh;
  width: 100vw; */
  /* background-color: #6c77d4; */
  /* box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2); */

/* } */

.payment-submitted-screen-top {
  position: absolute;
  top: 0vh;
  height: 20vh;
  /* width: 100vw; */
  margin: auto;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 400px; 
  /* outline:0.1em solid black;  */
  /* background-color: #687cd3; */
}
.success-screen-main {
  position: absolute;
  top: 21vh;
  height: 35vh;
  /* width: 100vw; */
  /* background-color: #68d3d3; */
  margin: auto;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 400px;
  /* outline:0.1em solid black;  */
}

.success-screen-email {
  position: absolute;
  top: 61vh;
  left: 0;
  right: 0;
  height: 5vh;
  width: 70%;
  margin: auto;
  /* width: 91%; */
  min-width: 100px; 
  max-width: 300px;
  display: flex;
  align-items: center;
  /* background-color: #687cd3; */
  justify-content: center;
  /* outline:0.1em solid black;  */
}

.cancelled-screen-main {
  position: absolute;
  top: 31vh;
  height: 35vh;
  /* width: 100vw; */
  /* background-color: #68d3d3; */
  margin: auto;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 400px;
  /* outline:0.1em solid black;  */
}

.tip-again {
  position: absolute;
  top: 70vh;
  height: 8vh;
  /* width: 100vw; */
  margin: auto;
  display: block;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 400px; 
  /* display: flex; */
  align-items: center;
  /* background-color: #687cd3; */
  /* outline:0.1em solid black;  */
}

.willsendemailtext {
  font-family: "LT", Helvetica, Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.35px;
  justify-content: center;

  color: #FFFFFF;
}

.standard-textbox {
  
  /* width: 100vw; */
  margin: auto;
  display: block;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 250px; 
  font-size: 16px;
  /* display: flex; */
  align-items: center;
  height: 4vh;
  padding-left: 12px;
  border:0.3px solid #b9b9c0;
  border-radius: 10px;
}

.input, select, textarea{
    color: #000066;
}

.input::placeholder{
  color: #87BBFD;
}

.notesInfoText{
  color: #000066;
  padding-top: clamp(2px, 1vh, 8px);
  font-size: clamp(2px, 4.5vh, 16px);
}

.notesInfoTextLarger{
  color: #000066;
  padding-top: clamp(2px, 1vh, 8px); 
  font-size: clamp(2px, 2.5vh, 16px);
}

/* Animation screenslideup */

.modal {
  display: flex;
  margin: 0 auto;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 400px; 
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: rgb(255, 255, 255);
  z-index: 996;
}

/* exactly the same as modal but modal is evidently a Bootstrap class which was conflicting with this version of modal. CAREFUL! remember that this is only a problem on the vue.app for the two modals here. It seemed to have a completely different further narrowing affect when I applied to all files replacing class="modal" which is weird given that the specs are literally the same for mobile*/
.modalnotbootstrap {
  display: flex;
  margin: 0 auto;
  width: 91%;
  min-width: 50px; /* Will be AT LEAST 20em wide */
  max-width: 400px; 
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background: rgb(255, 255, 255);
  z-index: 996;
}

.modalcontentwrapper {
  margin: auto; 
  width:90%; 
  outline:0.0em solid black; 
  height: 40vh
}

.modalcontentwrapperwrap {
  margin: auto; 
  width:90%; 
  outline:0.0em solid black; 
  padding-top: 5vh;
  padding-bottom: 5vh;
}


.modal-overlay {
  position: absolute;
  top: 0px;
  right:0;
  left:0;
  margin: auto;
  position: fixed;   /* for some reason, absolute on it own allowed a slight hoirzontal scroll bar effect appeared, no idea why - re-instating fixed fixed it */
  display:flex;
  justify-content:center; 
  align-items:center;
  z-index: 993;
  justify-content: center;
  background: #EDF2F7;
  height: 100%; 
  width: 100%
}


.modal-overlay-canscroll {
  /* position: absolute; */
  top: 0px;
  /* position: fixed; */
  /* position: fixed;   for some reason, absolute on it own allowed a slight hoirzontal scroll bar effect appeared, no idea why - re-instating fixed fixed it */
  display:flex;
  justify-content:center; 
  align-items:center;
  z-index: 993;
  justify-content: center;
  background: #EDF2F7;
  /* height: 100%;  */
  width: 100vw

}


.modal-overlayfrombottomblur {
  position: absolute;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  margin: auto;
  justify-content:center; 
  align-items:center;
  z-index: 994;
  justify-content: center;
  background: #EDF2F7;

  height: 100%; 
  width: 100vw; 
  background: rgba(0, 0, 0, .7); 
  display:flex; 
  flex-direction:column; 
  flex:1; 
  backdrop-filter: blur(1.5px);

}


.screenslideup-enter-from{
  transform: translateY(100vh);
}
.screenslideup-enter-to{
  transform: translateY(0px);
}
.screenslideup-enter-active{
  transition: all 0.2s ease;
}
.screenslideup-leave-from{
  transform: translateY(0px);
}
.screenslideup-leave-to{
  transform: translateY(100vh);
}
.screenslideup-leave-active{
  transition: all 0.2s ease;
}

.confirmslideup-enter-from{
  transform: translateY(100vh);
}
.confirmslideup-enter-to{
  transform: translateY(0vh);
}
.confirmslideup-enter-active{
  transition: all 0.3s linear;
}
.confirmslideup-leave-from{
  transform: translateY(0vh);
}
.confirmslideup-leave-to{
  transform: translateY(100vh);
}
.confirmslideup-leave-active{
  transition: all 0.3s ease;
}

.fade-enter-from{
  opacity: 0;
}
.fade-enter-to{
  opacity: 1;
}
.fade-enter-active{
  transition: all 0.2s linear;
}
.fade-leave-from{
  opacity: 1;
}
.fade-leave-to{
  opacity: 0;

}
.fade-leave-active{
  transition: all 0.2s ease;

}

/* END Animation screenslideup  */

/* start NEW HOME PAGE STYLE  */



/* End NEW HOME PAGE STYLE */


.highest-rated-animation{
  animation: 0.5s ease-out highest-rated-animation;
};

@keyframes highest-rated-animation {
  0% {
    transform: translateY(4vw);
    color: rgba(255.0, 255.0, 255.0, 0.0);
  }
  20% {
    transform: translateY(4vw);
    color: rgba(255.0, 255.0, 255.0, 0.1);
  }
  50% {
    color: rgba(255.0, 255.0, 255.0, 0.3);
  }
  100% {
    transform: translateY(0);
    color: rgba(0, 0, 102, 1.0);
  }
}

.transparent-simple-animation{
  animation: 0.7s ease-out transparent-simple-animation;

  
};

@keyframes transparent-simple-animation {
  0% {
    transform: translateX(-12vw);
    color: rgba(255.0, 255.0, 255.0, 0.0);
    /* to effect a delay */
  }
  80% {
    transform: translateX(-8vw);
    color: rgba(255.0, 255.0, 255.0, 0.3);
  }
  100% {
    transform: translateX(0);
    color: rgba(0, 0, 102, 1.0);
  }
}

.appear-text-animation{
  animation: 2.2s ease appear-text-animation;

  
};

@keyframes appear-text-animation {
  0% {
    /* transform: translateX(-12vw); */
    color: rgba(51.0, 51.0, 51.0, 0.0);
    /* to effect a delay */
  }
  60% {
    /* transform: translateX(-12vw); */
    color: rgba(51.0, 51.0, 51.0, 0.0);
    /* to effect a delay */
  }
  100% {
    /* transform: translateX(0); */
    color: rgba(51.0, 51.0, 51.0, 1.0);
  }
}

.hero-image-animation{
  animation: 1.2s ease hero-image-animation;

  
};

@keyframes hero-image-animation {
  0% {
    transform: translate(1vw, -0.3vw);
    /* transform: translateY(-2vw); */
    opacity: 0;
    /* to effect a delay */
  }
  20% {
    transform: translate(1vw, -0.3vw);
    
    opacity: 0;
  
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}

.fade-in-button-animation{
  animation: 2.2s ease fade-in-button-animation;

  
};

@keyframes fade-in-button-animation {
  0% {
    opacity: 0;
    /* to effect a delay */
  }
  20% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.spinner {
  margin: 2vh auto;
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #555;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

</style>
